import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import useColors from "../../../../api/hooks/useColors";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function MicrosoftAzureConnectForm({
  onSubmit,
  guideMode = false,
}) {
  const [showSecret, setShowSecret] = useState(false);
  const handleClickShowSecret = () => setShowSecret(!showSecret);
  const handleMouseDownSecret = () => setShowSecret(!showSecret);
  const formInitialValues = {
    clientId: "",
    clientSecret: "",
    tenantId: "",
    isGovTenant: false,
  };
  const formCheckoutSchema = yup.object().shape({
    clientId: yup.string().required("required"),
    clientSecret: yup.string().required("required"),
    tenantId: yup.string().required("required"),
    isGovTenant: yup.boolean(),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };
  const colors = useColors();

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="clientId"
                label="Application (client) ID"
                value={values.clientId}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.clientId && !!errors.clientId}
                helperText={touched.clientId && errors.clientId}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="tenantId"
                label="Directory (tenant) ID"
                value={values.tenantId}
                onBlur={handleBlur}
                onChange={handleChange}
                autoComplete="off"
                error={!!touched.tenantId && !!errors.tenantId}
                helperText={touched.tenantId && errors.tenantId}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="clientSecret"
                label="Client Secret Value"
                value={values.clientSecret}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.clientSecret && !!errors.clientSecret}
                helperText={touched.clientSecret && errors.clientSecret}
                type={showSecret ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle secret visibility"
                        onClick={handleClickShowSecret}
                        onMouseDown={handleMouseDownSecret}
                      >
                        {showSecret ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="isGovTenant"
                    checked={values.isGovTenant}
                    onChange={handleChange}
                    disabled={guideMode}
                  />
                }
                label={
                  <Box>
                    <Typography variant="body1">
                      Government Tenant (GCC)
                    </Typography>
                    <Typography variant="caption" color={colors.text_secondary}>
                      Check this box if you are connecting to a US Government
                      (GCC) tenant
                    </Typography>
                  </Box>
                }
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
